import { initializeApp } from 'firebase/app';
import { getMessaging, onMessage, getToken } from 'firebase/messaging';

export default function initFireBase(store) {
  const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_APIKEY,
    projectId: import.meta.env.VITE_FIREBASE_PROJECTID,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGINGSENDERID,
    appId: import.meta.env.VITE_FIREBASE_APPID,
  };
  const firebase = initializeApp(firebaseConfig);

  const messaging = getMessaging(firebase);

  getToken(messaging, { vapidKey: import.meta.env.VITE_FIREBASE_PUBLICKEY })
    .then(currentToken => {
      navigator.serviceWorker.addEventListener('message', message => {
        store.dispatch('sendNotification', {
          message: message.data.notification.body,
        });
      });
      if (currentToken) {
        store.dispatch('user.addDevice', currentToken);
      } else {
        console.log('No Instance ID token available. Request permission to generate one.');
      }
    })
    .catch(err => {
      console.log('An error occurred while retrieving token. ', err);
    });

  onMessage(messaging, payload => {
    console.log('Message received. ', payload);
  });
}
